  /* Copyright 2019 Google LLC All Rights Reserved.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
  ==============================================================================*/
  
export const COLORS = [
  "rgba(204, 0, 17, 1)",
  "rgba(0, 34, 68, 1)",
  "rgba(221, 221, 51, 1)",
  "rgba(0, 68, 136, 1)",
  "rgba(0, 51, 17, 1)",
  "rgba(17, 170, 170, 1)",
  "rgba(46, 102, 151, 1)",
  "rgba(155, 32, 6, 1)",
  "rgba(204, 0, 17, 1)",
  "rgba(17, 170, 170, 1)",
  "rgba(17, 170, 170, 1)"
];
